/* rr-lp.js — behaviour for the native Liquid ad landing pages (HLH, GOOGLE).
   Copied from assets/rr-neo.js + the inline <script> of snippets/rr-neo-buybox.liquid,
   re-prefixed neo- -> rlp-. Vanilla JS, no jQuery. Every interaction is delegated at
   document level so it survives the theme editor replacing the section DOM
   (shopify:section:load re-runs init()). */
(function () {
  "use strict";
  if (window.__rlpBound) return;
  window.__rlpBound = true;

  function closest(el, sel) {
    while (el && el.nodeType === 1) { if (el.matches(sel)) return el; el = el.parentElement; }
    return null;
  }
  function each(list, fn) { for (var i = 0; i < list.length; i++) fn(list[i], i); }
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------- Carousel (press strip) ---------------- */
  var AUTOPLAY_MS = 5000;
  function perView(root) {
    var pv = (root.getAttribute("data-rlp-per-view") || "3,2,1").split(",");
    var w = window.innerWidth;
    return parseInt(w <= 640 ? pv[2] : (w <= 1024 ? pv[1] : pv[0]), 10) || 1;
  }
  function pages(root) { return Math.max(1, Math.ceil(root.querySelectorAll(".rlp-carousel__slide").length / perView(root))); }
  function carouselRender(root) {
    var track = root.querySelector(".rlp-carousel__track");
    var dots = root.querySelector(".rlp-carousel__dots");
    var status = root.querySelector(".rlp-carousel__status");
    if (!track) return;
    var n = pages(root);
    var page = Math.min(parseInt(track.getAttribute("data-rlp-page") || "0", 10), n - 1);
    track.setAttribute("data-rlp-page", String(page));
    track.style.transform = "translateX(-" + page * 100 + "%)";
    if (status) status.textContent = "Page " + (page + 1) + " of " + n;
    if (dots) {
      if (n === 1) { dots.innerHTML = ""; }
      else {
        if (dots.children.length !== n) {
          dots.innerHTML = "";
          for (var i = 0; i < n; i++) {
            var d = document.createElement("button");
            d.type = "button"; d.className = "rlp-carousel__dot"; d.setAttribute("role", "tab");
            d.setAttribute("data-rlp-page-to", String(i)); d.setAttribute("aria-label", "Go to page " + (i + 1));
            dots.appendChild(d);
          }
        }
        for (var j = 0; j < dots.children.length; j++) dots.children[j].setAttribute("aria-current", j === page ? "true" : "false");
      }
    }
  }
  function carouselGo(root, delta, absolute) {
    var track = root.querySelector(".rlp-carousel__track");
    if (!track) return;
    var n = pages(root);
    var page = parseInt(track.getAttribute("data-rlp-page") || "0", 10);
    page = typeof absolute === "number" ? absolute : (page + delta + n) % n;
    track.setAttribute("data-rlp-page", String(page));
    carouselRender(root);
  }
  function carouselAutoplay(root) {
    if (reduceMotion || root.getAttribute("data-rlp-autoplay") === "1") return;
    root.setAttribute("data-rlp-autoplay", "1");
    var paused = false, x0 = null;
    setInterval(function () {
      if (!paused && document.visibilityState === "visible" && root.isConnected && pages(root) > 1) carouselGo(root, 1);
    }, AUTOPLAY_MS);
    // Hover-pause only for real hover pointers: on phones a tap fires a compat mouseenter with no
    // mouseleave, which would stop the autoplay for good.
    if (window.matchMedia && window.matchMedia("(hover: hover)").matches) {
      root.addEventListener("mouseenter", function () { paused = true; });
      root.addEventListener("mouseleave", function () { paused = false; });
    }
    root.addEventListener("focusin", function () { paused = true; });
    root.addEventListener("focusout", function () { paused = false; });
    root.addEventListener("touchstart", function (e) { paused = true; x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (x0 !== null) { var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) carouselGo(root, dx < 0 ? 1 : -1); }
      x0 = null; paused = false;
    }, { passive: true });
  }

  /* ---------------- Buy box ---------------- */
  var cartKnownEmpty = null; // null = unknown; true/false once /cart.js answers
  function prefetchCart() {
    try {
      fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (c) { cartKnownEmpty = !!(c && c.item_count === 0); })
        .catch(function () { cartKnownEmpty = null; });
    } catch (e) { cartKnownEmpty = null; }
  }

  function bbState(root) {
    return { color: root.getAttribute("data-color") || "dove", tier: root.getAttribute("data-tier") || "2" };
  }
  function bbRender(root) {
    var st = bbState(root);
    each(root.querySelectorAll(".rlp-bb__swatch"), function (b) {
      var on = b.getAttribute("data-color") === st.color;
      b.classList.toggle("is-selected", on); b.setAttribute("aria-checked", on ? "true" : "false");
    });
    each(root.querySelectorAll(".rlp-bb__opt"), function (o) {
      var on = o.getAttribute("data-tier") === st.tier;
      o.classList.toggle("is-selected", on);
      var btn = o.querySelector(".rlp-bb__tier");
      if (btn) btn.setAttribute("aria-checked", on ? "true" : "false");
      if (btn) {
        var c = st.color;
        var set = function (sel, attr) { var el = o.querySelector(sel); if (el) el.textContent = btn.getAttribute(attr + c) || ""; };
        set(".rlp-bb__price", "data-price-");
        set(".rlp-bb__compare", "data-compare-");
        set(".rlp-bb__save", "data-save-");
      }
    });
    each(root.querySelectorAll(".rlp-bb__product-img"), function (img) {
      img.hidden = !(img.getAttribute("data-tier") === st.tier && img.getAttribute("data-color") === st.color);
    });
    /* FIX-E: the no-JS form's hidden id follows the selection (progressive enhancement). */
    var idIn = root.querySelector("[data-rlp-id]");
    var sel = root.querySelector('.rlp-bb__opt[data-tier="' + st.tier + '"] .rlp-bb__tier');
    var vid = sel ? sel.getAttribute("data-variant-" + st.color) : null;
    if (idIn && vid) idIn.value = vid;
  }

  /* FIX-E (R2 E1): never show a raw browser error ("Failed to fetch" / Safari "Load failed") to a buyer. */
  function friendlyError(e) {
    var msg = (e && e.message) || "";
    if (!e || e.name === "TypeError" || /fetch|network|load failed|connection/i.test(msg)) {
      return "We couldn\u2019t reach the store. Please check your connection and tap the button to try again.";
    }
    if (e.name === "SyntaxError") return "Something went wrong on our side. Please tap the button to try again.";
    return msg;
  }

  function addToCart(root, btn) {
    if (btn.disabled) return;
    var st = bbState(root);
    var opt = root.querySelector('.rlp-bb__opt[data-tier="' + st.tier + '"] .rlp-bb__tier');
    var variantId = opt ? opt.getAttribute("data-variant-" + st.color) : null;
    var label = btn.querySelector(".rlp-bb__atc-label");
    var err = root.querySelector(".rlp-bb__atc-error");
    if (!variantId) {
      if (err) { err.textContent = "This option is not available right now. Please pick another."; err.hidden = false; }
      return;
    }
    if (err) { err.hidden = true; err.textContent = ""; }
    if (!btn.hasAttribute("data-idle")) btn.setAttribute("data-idle", label ? label.textContent : "ADD TO CART");
    btn.disabled = true;
    btn.setAttribute("data-busy-now", "1");
    if (label) label.textContent = "TAKING YOU TO CHECKOUT…";
    // Same flow as the live NEO page: skip the clear when the cart is known empty.
    var maybeClear = cartKnownEmpty === true
      ? Promise.resolve()
      : fetch("/cart/clear.js", { method: "POST", headers: { Accept: "application/json" }, credentials: "same-origin" });
    maybeClear
      .then(function () {
        return fetch("/cart/add.js", {
          method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        });
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error((d && d.description) || "Could not add this item to your cart."); });
        return res.json();
      })
      .then(function () { window.location.href = "/checkout"; })
      .catch(function (e) {
        /* A retry must start from a known cart: the add may have landed before the connection dropped. */
        cartKnownEmpty = null;
        btn.disabled = false;
        btn.removeAttribute("data-busy-now");
        if (label) label.textContent = "TRY AGAIN";
        if (err) { err.textContent = friendlyError(e); err.hidden = false; }
      });
  }

  /* FIX-E (R2 F11): Safari restores the page from the back/forward cache after the shopper backs out of checkout;
     the button must not stay disabled on "TAKING YOU TO CHECKOUT…". */
  window.addEventListener("pageshow", function (ev) {
    each(document.querySelectorAll(".rlp .rlp-bb__atc"), function (btn) {
      if (!ev.persisted && !btn.hasAttribute("data-busy-now")) return;
      btn.disabled = false;
      btn.removeAttribute("data-busy-now");
      var label = btn.querySelector(".rlp-bb__atc-label");
      if (label && btn.getAttribute("data-idle")) label.textContent = btn.getAttribute("data-idle");
    });
    if (ev.persisted) { cartKnownEmpty = null; prefetchCart(); each(document.querySelectorAll(".rlp .rlp-bb"), bbRender); }
  });

  /* ---- FIX-E (R2 F1/F8): in-page jumps that land on the target even while lazy images above it load.
     Smooth-scroll, wait for the scroll to come to rest, re-measure and correct (up to 5 times), then keep watching
     for 1.2 s (iOS Safari has no scroll anchoring). A real touch/wheel/key by the shopper cancels the correction. ---- */
  var jump = null;
  function cancelJump() { if (jump) { jump.cancelled = true; jump = null; } }
  ["wheel", "touchstart", "keydown", "mousedown"].forEach(function (ev) {
    window.addEventListener(ev, function (e) { if (jump && e.isTrusted && performance.now() - jump.t0 > 120) cancelJump(); }, { passive: true });
  });
  function sticks(el) {
    if (getComputedStyle(el).position !== "sticky") return false;
    for (var p = el.parentElement; p && p !== document.body && p !== document.documentElement; p = p.parentElement) {
      var cs = getComputedStyle(p);
      if (/(hidden|auto|scroll)/.test(cs.overflowX + " " + cs.overflowY)) return false;
    }
    return true;
  }
  function headerOffset() {
    var h = document.querySelector(".rlp .rlp-header");
    if (!h || !sticks(h)) return 8;
    return Math.round(h.getBoundingClientRect().height + 8);
  }
  function jumpTo(target) {
    cancelJump();
    var j = jump = { cancelled: false, tries: 0, t0: performance.now() };
    function dest() { return Math.max(0, Math.round(target.getBoundingClientRect().top + window.pageYOffset - headerOffset())); }
    function maxY() { return document.documentElement.scrollHeight - window.innerHeight; }
    function move(y, smooth) {
      if (smooth && !reduceMotion) { window.scrollTo({ top: y, behavior: "smooth" }); return; }
      var de = document.documentElement, prev = de.style.scrollBehavior;
      de.style.scrollBehavior = "auto"; window.scrollTo(0, y); de.style.scrollBehavior = prev;
    }
    function settled() {
      [400, 1200].forEach(function (ms) {
        setTimeout(function () {
          if (j.cancelled) return;
          var d = dest(), y = window.pageYOffset;
          if (Math.abs(d - y) > 8 && !(y >= maxY() - 1 && d > y)) move(d, false);
          if (ms === 1200 && jump === j) jump = null;
        }, ms);
      });
    }
    var last = -1, still = 0, started = performance.now();
    function poll() {
      if (j.cancelled) return;
      var y = window.pageYOffset;
      still = Math.abs(y - last) < 1 ? still + 1 : 0;
      last = y;
      var elapsed = performance.now() - started;
      if ((still < 4 || elapsed < 250) && elapsed < 3500) { requestAnimationFrame(poll); return; }
      var d = dest();
      if (Math.abs(d - y) > 2 && !(y >= maxY() - 1 && d > y) && j.tries < 5) {
        j.tries++;
        move(d, Math.abs(d - y) > 240);
        last = -1; still = 0; started = performance.now();
        requestAnimationFrame(poll);
        return;
      }
      settled();
    }
    move(dest(), true);
    requestAnimationFrame(poll);
  }

  /* ---------------- Videos ---------------- */
  function heroLoad(media) {
    var v = media.querySelector(".rlp-hero__video");
    if (!v || v.getAttribute("data-loaded")) return;
    v.setAttribute("data-loaded", "1");
    /* FIX-E (R2 speed T6): always the capped mp4 (480p phones / 720p desktop). The HLS stream let desktop browsers with native HLS
       pull the 1080p rendition (15.6 MB); data-src-hls stays in the markup only as a last-resort fallback. */
    var small = window.innerWidth < 768;
    v.src = (small ? v.getAttribute("data-src-mobile") : v.getAttribute("data-src-desktop")) || v.getAttribute("data-src-hls") || "";
    v.addEventListener("error", function onErr() {
      v.removeEventListener("error", onErr);
      var fb = v.getAttribute("data-src-fallback");
      if (fb && v.src.indexOf(fb) === -1) { v.src = fb; var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); }
    });
    v.addEventListener("playing", function () { media.classList.add("is-playing"); });
    v.muted = true;
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function heroInit() {
    each(document.querySelectorAll(".rlp .rlp-hero__media"), function (media) {
      if (media.getAttribute("data-rlp-init")) return;
      media.setAttribute("data-rlp-init", "1");
      var btn = media.querySelector(".rlp-hero__play");
      var tapToPlay = window.innerWidth < 768 && media.getAttribute("data-mobile-autoplay") !== "true";
      if (tapToPlay) { if (btn) btn.hidden = false; return; }
      if (btn) btn.hidden = true;
      // Desktop: autoplay muted, but only after the load event so the video never competes with LCP.
      var start = function () {
        if ("IntersectionObserver" in window) {
          var io = new IntersectionObserver(function (entries) {
            if (entries.some(function (e) { return e.isIntersecting; })) { heroLoad(media); io.disconnect(); }
          }, { rootMargin: "200px 0px" });
          io.observe(media);
        } else heroLoad(media);
      };
      if (document.readyState === "complete") start(); else window.addEventListener("load", start, { once: true });
    });
  }
  function founderPlay(facade) {
    var id = facade.getAttribute("data-vimeo-id");
    if (!id || facade.querySelector("iframe")) return;
    var f = document.createElement("iframe");
    f.src = "https://player.vimeo.com/video/" + encodeURIComponent(id) + "?autoplay=1&title=0&byline=0&portrait=0&dnt=1";
    f.allow = "autoplay; fullscreen; picture-in-picture";
    f.allowFullscreen = true;
    f.title = facade.getAttribute("data-title") || "Video";
    facade.innerHTML = "";
    facade.appendChild(f);
  }

  /* ---------------- Delegated clicks ---------------- */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!closest(t, ".rlp")) return;

    var faq = closest(t, ".rlp-faq-item__q");
    if (faq) {
      var item = closest(faq, ".rlp-faq-item");
      var panel = item ? item.querySelector(".rlp-faq-item__a") : null;
      var open = faq.getAttribute("aria-expanded") === "true";
      faq.setAttribute("aria-expanded", String(!open));
      if (panel) { if (open) panel.setAttribute("hidden", ""); else panel.removeAttribute("hidden"); }
      return;
    }

    var root = closest(t, ".rlp-bb");
    if (root) {
      var sw = closest(t, ".rlp-bb__swatch");
      if (sw) { root.setAttribute("data-color", sw.getAttribute("data-color")); bbRender(root); return; }
      var inc = closest(t, ".rlp-bb__inc-toggle");
      if (inc) {
        var list = document.getElementById(inc.getAttribute("aria-controls"));
        var ex = inc.getAttribute("aria-expanded") === "true";
        inc.setAttribute("aria-expanded", String(!ex));
        if (list) list.hidden = ex;
      }
      var opt = closest(t, ".rlp-bb__opt");
      if (opt) { root.setAttribute("data-tier", opt.getAttribute("data-tier")); bbRender(root); return; }
      var acc = closest(t, ".rlp-bb__acc-btn");
      if (acc) {
        var exp = acc.getAttribute("aria-expanded") === "true";
        acc.setAttribute("aria-expanded", String(!exp));
        var pnl = document.getElementById(acc.getAttribute("aria-controls"));
        if (pnl) pnl.hidden = exp;
        return;
      }
      var atc = closest(t, ".rlp-bb__atc");
      if (atc) { e.preventDefault(); addToCart(root, atc); return; }
    }

    var dot = closest(t, "[data-rlp-page-to]");
    if (dot) { var car = closest(dot, ".rlp-carousel"); if (car) carouselGo(car, 0, parseInt(dot.getAttribute("data-rlp-page-to"), 10)); return; }

    var hp = closest(t, ".rlp-hero__play");
    if (hp) {
      var media = closest(hp, ".rlp-hero__media");
      hp.hidden = true;
      if (media) { var v = media.querySelector(".rlp-hero__video"); if (v) v.controls = true; heroLoad(media); }
      return;
    }

    var facade = closest(t, ".rlp-video[data-vimeo-id]");
    if (facade) { e.preventDefault(); founderPlay(facade); return; }

    var link = closest(t, 'a[href^="#"]');
    if (link) {
      var id = link.getAttribute("href").slice(1);
      var target = id ? document.getElementById(id) : null;
      if (!target) return;
      e.preventDefault();
      jumpTo(target);
    }
  }, true);

  /* FIX-E: the ATC is a submit button inside a real /cart/add form; with JS we keep the fast clear + add + /checkout flow. */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains("rlp-bb__form")) return;
    var root = closest(form, ".rlp-bb");
    var btn = form.querySelector(".rlp-bb__atc");
    if (!root || !btn) return;
    e.preventDefault();
    addToCart(root, btn);
  }, true);

  /* ---------------- Sticky CTA ---------------- */
  function stickyInit() {
    var bar = document.querySelector(".rlp .rlp-sticky-cta");
    var bb = document.querySelector(".rlp .rlp-bb");
    var heroCta = document.querySelector(".rlp .rlp-hero .rlp-btn-pill");
    if (!bar || !bb || bar.getAttribute("data-rlp-observed")) return;
    bar.setAttribute("data-rlp-observed", "1");
    /* Hidden while the hero button is still on screen (the headline + CTA now sit at the top on
       phones, so a second yellow button at first paint was a duplicate) and while the buy box is
       on screen (as NEO). rAF-throttled passive scroll check, no layout reads beyond two rects. */
    var raf = null, state = null;
    function check() {
      raf = null;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var heroGone = !heroCta || heroCta.getBoundingClientRect().bottom < 0;
      var r = bb.getBoundingClientRect();
      var bbVisible = r.top < vh * 0.85 && r.bottom > vh * 0.15;
      var on = heroGone && !bbVisible;
      if (on === state) return;
      state = on;
      bar.style.opacity = on ? "1" : "0";
      bar.style.pointerEvents = on ? "auto" : "none";
      if (on) bar.removeAttribute("inert"); else bar.setAttribute("inert", "");
    }
    window.addEventListener("scroll", function () { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
    window.addEventListener("resize", function () { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
    check();
  }

  /* ---------------- Okendo (lazy) ---------------- */
  function okendoInit() {
    var host = document.querySelector(".rlp [data-rlp-okendo]");
    if (!host || window.__rlpOkendoLoaded) return;
    var load = function () {
      if (window.__rlpOkendoLoaded) return;
      window.__rlpOkendoLoaded = true;
      var css = host.getAttribute("data-rlp-okendo-css");
      if (css && !document.querySelector('link[href*="okendo.io/styles/main.min.css"]')) {
        var l = document.createElement("link"); l.rel = "stylesheet"; l.href = css; document.head.appendChild(l);
      }
      var sc = document.createElement("script");
      sc.src = host.getAttribute("data-rlp-okendo"); sc.defer = true;
      document.head.appendChild(sc);
      /* FIX-E: collapse the reserved 600 px if the widget has not rendered after 10 s (CDN down or blocked). */
      setTimeout(function () {
        var w = host.querySelector("[data-oke-widget]");
        if (w && !w.children.length) host.classList.add("is-oke-empty");
      }, 10000);
    };
    if (!("IntersectionObserver" in window)) { load(); return; }
    var io = new IntersectionObserver(function (en) {
      if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); load(); }
    }, { rootMargin: "1200px 0px 1200px 0px" });
    io.observe(host);
  }

  function init() {
    each(document.querySelectorAll(".rlp .rlp-carousel"), function (c) { carouselRender(c); carouselAutoplay(c); });
    each(document.querySelectorAll(".rlp .rlp-bb"), bbRender);
    heroInit();
    stickyInit();
    okendoInit();
  }

  prefetchCart();
  if (document.readyState !== "loading") init(); else document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
  var rt = null;
  window.addEventListener("resize", function () {
    clearTimeout(rt);
    rt = setTimeout(function () { each(document.querySelectorAll(".rlp .rlp-carousel"), carouselRender); }, 150);
  });
})();
